import { render, staticRenderFns } from "./PatentAnnuityForm.vue?vue&type=template&id=cb570d80&"
import script from "./PatentAnnuityForm.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnnuityForm.vue?vue&type=style&index=0&id=cb570d80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports